<template>
  <header>
    <div class="header-container">

      <!-- Toggle do menu (mobile) -->
      <input id="atv-menu" type="checkbox" class="menu-checkbox" v-model="menuOpen" />
      <label for="atv-menu" class="menu-toggle" aria-label="Abrir menu">
        <span class="hamburger"></span>
      </label>
      

      <div class="info-principal">
        <router-link :to="{ path: '/' }">
          <img src="../assets/images/logo_legisla.png" class="logo-header" alt="Logo Legisla Goiás" />
        </router-link>
        <p>
          O <strong>LEGISLA GOIÁS</strong> é a plataforma oficial de publicidade e acesso à legislação do <strong>Estado de Goiás</strong>, assegurando transparência, atualização contínua e facilidade de consulta às normas legais e infralegais do Poder Executivo.
        </p>
      </div>

      <div class="links-navegacao" :class="{ 'only-estadual-right': isRotaLegislacaoMunicipal }">
        <template v-if="isEnteFederativoPage">
          <router-link :to="{ name: 'LegislacaoPorEnteFederativoBySlug', params: { slug: $route.params.slug } }" class="btn-ente-federativo">
            Legislação Municipal
          </router-link>
          <router-link 
            v-if="temAtosAdministrativos" 
            :to="{ name: 'AtosAdministrativosPorEnteFederativo', params: { slug: $route.params.slug } }" 
            class="btn-ente-federativo"
          >
            Índice de Atos<br /> Administrativos
          </router-link>
          <router-link 
            v-if="temAtosInfralegais" 
            :to="{ name: 'AtosInfralegaisPorEnteFederativo', params: { slug: $route.params.slug } }" 
            class="btn-ente-federativo"
          >
            Atos<br /> Infralegais
          </router-link>
          <router-link 
            v-if="temMensagensVeto" 
            :to="{ name: 'MensagensVetoPorEnteFederativo', params: { slug: $route.params.slug } }" 
            class="btn-ente-federativo"
          >
            Mensagem<br /> de Veto
          </router-link>
          <router-link :to="{ name: 'PesquisaLegislacaoMunicipal' }" class="btn-ente-federativo">
            Outros Municípios
          </router-link>
          <router-link :to="{ name: 'PesquisaLegislacao' }" class="btn-ente-federativo btn-legislacao-estadual">
            Legislação Estadual
          </router-link>
        </template>
        <template v-else-if="isRotaLegislacaoMunicipal">
          <!-- Na página de seleção de ente federativo, mostrar apenas Legislação Estadual -->
          <router-link :to="{ name: 'PesquisaLegislacao' }" class="btn-legislacao-estadual">
            Legislação Estadual
          </router-link>
        </template>
        <template v-else>
          <div class="has-submenu">
            <router-link
              :to="{ name: 'PesquisaLegislacao' }"
              :class="{ 'router-link-exact-active': isLegislacaoEstadualActive, 'esconder-mobile': true }"
            >
              Legislação Estadual
            </router-link>
            <div class="coluna-links">
              <router-link :to="{ name: 'PesquisaLegislacao' }">Leis e Decretos</router-link>
              <router-link :to="{ name: 'ConstituicaoEstadual' }" target="_blank">Constituição Estadual</router-link>
              <router-link :to="{ name: 'CadastroAcompanhamentoPublicacoes' }">Acompanhamento de Publicações</router-link>
              <router-link :to="{ name: 'EntendaLegislacao' }">Entenda a Legislação Estadual</router-link>
            </div>
          </div>
          <router-link
            :to="{ name: 'PesquisaIndexAtoAdministrativo' }"
            :class="{ 'router-link-exact-active': isAtoAdministrativoActive }"
          >
            Índice de Atos<br /> Administrativos
          </router-link>
          <router-link
            :to="{ name: 'PesquisaAtoInfralegal' }"
            :class="{ 'router-link-exact-active': isAtoInfralegalActive }"
          >
            Atos<br /> Infralegais
          </router-link>
          <router-link
            :to="{ name: 'ProjetosGovernador' }"
            :class="{ 'router-link-exact-active': isProjetosGovernadorActive }"
          >
            Projetos de Autoria<br /> do Governador
          </router-link>
          <router-link
            :to="{ name: 'PesquisaMensagemVeto' }"
            :class="{ 'router-link-exact-active': isMensagemVetoActive }"
          >
            Mensagem<br /> de Veto
          </router-link>
          <router-link v-if="!isRotaLegislacaoMunicipal"
            :to="{ name: 'PesquisaLegislacaoMunicipal' }"
            :class="['btn-municipal', { 'router-link-exact-active': isRotaLegislacaoMunicipal }]"
            aria-label="Legislação Municipal"
            title="Legislação Municipal"
          >
            <img
              src="@/assets/images/legisla-municipios.png"
              alt="Legislação Municipal"
              class="icon-municipal"
            />
          </router-link>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";

export default {
  name: "Menu",
  data() {
    return {
      menuOpen: false,
      temAtosAdministrativos: true, // Por padrão, assume que tem atos administrativos
      temAtosInfralegais: true, // Por padrão, assume que tem atos infralegais
      temMensagensVeto: true, // Por padrão, assume que tem mensagens de veto
      legislacaoApi: null,
      verificandoAtosAdministrativos: false, // Flag para evitar múltiplas verificações simultâneas
      verificandoAtosInfralegais: false, // Flag para evitar múltiplas verificações simultâneas
      verificandoMensagensVeto: false, // Flag para evitar múltiplas verificações simultâneas
    };
  },
  watch: {
    $route() {
      this.menuOpen = false;
      // Verificar dados quando a rota mudar
      if (this.isEnteFederativoPage) {
        this.verificarTodosOsDados();
      }
    },
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    // Verificar dados quando o componente for criado
    if (this.isEnteFederativoPage) {
      this.verificarTodosOsDados();
    }
  },
  computed: {
    isRotaLegislacaoMunicipal() {
      return Boolean(this.$route.meta && this.$route.meta.isMunicipalLegislation);
    },
    isEnteFederativoPage() {
      return !!this.$route.params.slug;
    },
    isLegislacaoEstadualActive() {
      const nomes = [
        'PesquisaLegislacao',
        'PorTipoLegislacao',
        'PorCategoriaLegislacao',
        'PorAutorLegislacao',
        'PorAnoLegislacao',
      ];
      return nomes.includes(this.$route.name);
    },
    isAtoInfralegalActive() {
      const nomes = [
        'PesquisaAtoInfralegal',
        'PorTipoAtoInfralegal',
        'PorOrgaoAtoInfralegal',
        'PorAnoAtoInfralegal',
      ];
      return nomes.includes(this.$route.name);
    },
    isAtoAdministrativoActive() {
      const nomes = [
        'PesquisaIndexAtoAdministrativo',
        'PorAnoAtoAdministrativo',
        'PorTipoAtoAdministrativo',
      ];
      return nomes.includes(this.$route.name);
    },
    isProjetosGovernadorActive() {
      const nomes = [
        'ProjetosGovernador',
        'PorAnoProjetoGovernador',
      ];
      return nomes.includes(this.$route.name);
    },
    isMensagemVetoActive() {
      const nomes = [
        'PesquisaMensagemVeto',
        'PorTipoVetoMensagemVeto',
        'PorAnoMensagemVeto',
        'PorTipoLegislacaoMensagemVeto',
      ];
      return nomes.includes(this.$route.name);
    },
  },
  methods: {
    async verificarAtosAdministrativos(enteFederativoId) {
      // Evitar múltiplas verificações simultâneas
      if (this.verificandoAtosAdministrativos) {
        return;
      }

      this.verificandoAtosAdministrativos = true;

      try {
        // Verificar se há atos administrativos para este ente federativo
        const data = await this.legislacaoApi.getAtosAdministrativosByEnteFederativo(
          enteFederativoId, 
          { qtd_por_pagina: 1, page: 1 }
        );
        
        // Se total_resultados for maior que 0, há atos administrativos
        this.temAtosAdministrativos = data.total_resultados > 0;
      } catch (error) {
        console.error('Erro ao verificar atos administrativos:', error);
        // Em caso de erro, mantém como true para não quebrar a funcionalidade
        this.temAtosAdministrativos = true;
      } finally {
        this.verificandoAtosAdministrativos = false;
      }
    },

    async verificarTodosOsDados() {
      try {
        // Obter o ente federativo uma única vez
        const entesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = entesFederativos.find(ente => ente.slug === this.$route.params.slug);
        
        if (!enteFederativo) {
          // Se não encontrar o ente federativo, ocultar todos os menus
          this.temAtosAdministrativos = false;
          this.temAtosInfralegais = false;
          this.temMensagensVeto = false;
          return;
        }

        // Executar todas as verificações em paralelo para melhor performance
        await Promise.all([
          this.verificarAtosAdministrativos(enteFederativo.id),
          this.verificarAtosInfralegais(enteFederativo.id),
          this.verificarMensagensVeto(enteFederativo.id)
        ]);
      } catch (error) {
        console.error('Erro ao verificar dados do ente federativo:', error);
        // Em caso de erro, mantém todos como true para não quebrar a funcionalidade
        this.temAtosAdministrativos = true;
        this.temAtosInfralegais = true;
        this.temMensagensVeto = true;
      }
    },

    async verificarAtosInfralegais(enteFederativoId) {
      // Evitar múltiplas verificações simultâneas
      if (this.verificandoAtosInfralegais) {
        return;
      }

      this.verificandoAtosInfralegais = true;

      try {
        // Verificar se há atos infralegais para este ente federativo
        const data = await this.legislacaoApi.getAtosInfralegaisByEnteFederativo(
          enteFederativoId, 
          { qtd_por_pagina: 1, page: 1 }
        );
        
        // Se total_resultados for maior que 0, há atos infralegais
        this.temAtosInfralegais = data.total_resultados > 0;
      } catch (error) {
        console.error('Erro ao verificar atos infralegais:', error);
        // Em caso de erro, mantém como true para não quebrar a funcionalidade
        this.temAtosInfralegais = true;
      } finally {
        this.verificandoAtosInfralegais = false;
      }
    },

    async verificarMensagensVeto(enteFederativoId) {
      // Evitar múltiplas verificações simultâneas
      if (this.verificandoMensagensVeto) {
        return;
      }

      this.verificandoMensagensVeto = true;

      try {
        // Verificar se há mensagens de veto para este ente federativo
        const data = await this.legislacaoApi.getMensagensVetoByEnteFederativo(
          enteFederativoId, 
          { qtd_por_pagina: 1, page: 1 }
        );
        
        // Se total_resultados for maior que 0, há mensagens de veto
        this.temMensagensVeto = data.total_resultados > 0;
      } catch (error) {
        console.error('Erro ao verificar mensagens de veto:', error);
        // Em caso de erro, mantém como true para não quebrar a funcionalidade
        this.temMensagensVeto = true;
      } finally {
        this.verificandoMensagensVeto = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: #115810; /* Cor verde escura do fundo */
  color: #ffffff; /* Cor do texto branca */
  padding: 1rem 1rem;
  font-family: 'Poppins', sans-serif; /* Certifique-se que a fonte está correta */
  position: relative; /* ancora o botão hamburger */
}

.header-container {
  display: grid;
  grid-template-columns: 1fr; /* Uma coluna para mobile */
  grid-template-areas:
    "info"
    "links"
    "direita"
    "navegacao";
  // gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

/* Toggle do menu (mobile) */
.menu-checkbox { display: none; }
.menu-toggle {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
}
.hamburger {
  position: relative;
  width: 1.5rem;
  height: 2px;
  background: #fff;
  display: block;
}
.hamburger::before,
.hamburger::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  transition: 0.35s ease-in-out;
}
.hamburger::before { top: -6px; }
.hamburger::after { top: 6px; }

/* Efeito X quando aberto */
#atv-menu:checked + label .hamburger { background: transparent; }
#atv-menu:checked + label .hamburger::before { transform: rotate(45deg); top: 0; }
#atv-menu:checked + label .hamburger::after { transform: rotate(-45deg); top: 0; }

/* Áreas do Grid */
.coluna-links { grid-area: links; }
.info-principal { grid-area: info; }
.coluna-direita { grid-area: direita; }
.links-navegacao { grid-area: navegacao; }


/* Estilos das Colunas */
.coluna-links {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
  a {
    color: #ffb24e;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    transition: all 0.2s ease-in-out;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
  }
  a:hover {
    // background-color: #ffb24e;
    color: #0e489f;
  }
}

/* Alto contraste: garante links do submenu em branco */
:deep(.alto-contraste) .links-navegacao .coluna-links a {
  color: #ffffff !important;
}

:deep(.alto-contraste) .links-navegacao .coluna-links a:hover,
:deep(.alto-contraste) .links-navegacao .coluna-links a.router-link-active,
:deep(.alto-contraste) .links-navegacao .coluna-links a.router-link-exact-active {
  background-color: transparent;
  color: #ffffff !important;
}

.info-principal {
  .logo-header {
    max-width: 250px;
    margin-bottom: 2rem;
  }
  p {
    color: white;
    font-size: 0.9rem;
    line-height: 1.6;
    max-width: auto; // sugestão de alterações para Nilton
    margin: 0 auto;
    strong {
        font-weight: bold;
    }
  }
}

.coluna-direita {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}

/* Navegação Inferior */
.links-navegacao {
  padding-top: 1rem;
  border-top: none; /* substituída por pseudo-elemento para encurtar a linha */
  position: relative;
  // margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  /* linha superior centralizada e mais curta, mantendo a espessura (usada no desktop) */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 180px; /* comprimento reduzido no mobile */
    height: 4px; /* mesma espessura da borda anterior */
    background-color: #ffb24e;
    pointer-events: none;
  }

  /* Estilo para os LINKS PRINCIPAIS (filhos diretos) */
  > a, .has-submenu > a {
    color: white;
    text-decoration: none;
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    display: inline-block;
    width: fit-content;
    height: auto;
    overflow: hidden;
  }

  /* Hover para os LINKS PRINCIPAIS */
  > a:hover,
  .has-submenu > a:hover {
    background-color: #ffb24e;
    color: #0e489f;
  }

  /* Ativo (apenas match exato) para os LINKS PRINCIPAIS */
  > a.router-link-exact-active,
  .has-submenu > a.router-link-exact-active {
    background-color: #ffb24e;
    color: #0e489f;
    font-weight: 900; /* ativo mais forte */
    text-shadow: 0 1px 1px rgba(0,0,0,0.35); /* mais forte para contraste */
  }
  .btn-municipal {
    background-color: #efeeed;
    color: #ffb24e;
    padding: 0.2rem 0.4rem; /* igual aos outros links */
    border-radius: 4px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.2s ease-in-out; /* igual aos outros links */
    display: inline-block;
    text-align: center;
    align-self: center; /* evita esticar na coluna (mobile) */
    white-space: nowrap;
    width: fit-content;
    &:hover {
        background-color: #d3d4d3; /* mesmo hover dos outros links */
        color: #0e489f;
    }
  }

  .btn-ente-federativo {
    // background-color: #0e489f;
    // color: #ffb24e;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    width: fit-content;
    white-space: nowrap;
    &:hover {
        // background-color: #ffb24e;
        color: #0e489f;
    }
  }

  .btn-ente-federativo.router-link-exact-active {
    background-color: #ffb24e;
    color: #0e489f;
  }

  .btn-ente-federativo.btn-legislacao-estadual {
    background-color: #115810;
    color: #ffb24e;
  }

  .btn-legislacao-estadual {
    background-color: #115810;
    color: #ffb24e;
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    width: fit-content;
    white-space: nowrap;
    &:hover {
        background-color: #ffb24e;
        color: #0e489f;
    }
  }
}

/* Estilo específico para os links do SUBMENU (dentro da .coluna-links) */
.coluna-links {
  align-items: center; /* evita esticar largura; visual como os outros links */
  a {
    // color: #ffb24e; /* igual aos demais links principais */
    // font-family: 'Poppins-Extralight';
    // font-weight: bold;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    // font-size: 0.9rem; /* menor que os links principais */
    padding: 0.2rem; /* igual aos demais */
    border-radius: 4px; /* igual aos demais */
    display: inline-block;
    line-height: 1.3;
    text-align: center;
  }

  /* Hover no mesmo padrão dos demais links */
  a:hover {
    background-color: #ffb24e;
    color: #0e489f;
    border-radius: 4px;
  }

  /* Estado ativo no mesmo padrão dos demais links */
  a.router-link-active,
  a.router-link-exact-active {
    background-color: #ffb24e;
    color: #0e489f;
    border-radius: 4px;
    font-weight: 900; /* ativo mais forte */
    text-shadow: 0 1px 1px rgba(0,0,0,0.35); /* mais forte para contraste */
  }
}

/* --- MOBILE OVERLAY MENU --- */
@media (max-width: 1023px) {
  .links-navegacao {
    position: fixed;
    top: -80rem; /* escondido fora da tela */
    left: 0;
    width: 100%;
    background: #efeeed;
    z-index: 4000;
    border-bottom: 0.15rem solid #ffb24e;
    padding: 2rem 0rem;
    gap: 1.5rem;
    align-items: center;
    transition: top 0.35s ease-in-out;
  }

  .links-navegacao::before { display: none; }

  /* Abre menu quando checkbox está marcado */
  #atv-menu:checked ~ .links-navegacao {
    top: 4rem; /* altura aproximada do header */
  }

  /* Cores do overlay */
  .links-navegacao > a,
  .links-navegacao .has-submenu > a {
    color: #115810;
    background: transparent;
  }

  .links-navegacao .coluna-links a {
    color: #115810;
  }

  .links-navegacao .has-submenu > a.esconder-mobile {
    display: none;
  }
}

/* --- ESTILOS PARA DESKTOP --- */
@media (min-width: 1024px) {
  header {
    // padding: 2rem 2rem; // sugestão de alterações para Nilton
    padding-bottom: 1rem;
  }

  .header-container {
    grid-template-columns: 1fr 4.5fr 1fr; // sugestão de alterações para Nilton
    grid-template-rows: auto auto;
    grid-template-areas:
      "links info direita"
      "navegacao navegacao navegacao";
    gap: 1rem 1rem; // sugestão de alterações para Nilton
  }

  .coluna-links {
    text-align: left;
    justify-content: center;
    gap: 0.8rem;
  }

  .coluna-direita {
    justify-content: space-between;
    align-items: flex-end;
  }

  .info-principal .logo-header {
    max-width: 450px; // sugestão de alterações para Nilton
    margin-bottom: 1rem; // sugestão de alterações para Nilton
  }

  .links-navegacao {
    flex-direction: row;
    justify-content: center;
    gap: 4.3rem;

    /* linha um pouco maior no desktop */
    &::before {
      width: 260px;
    }
    /* no desktop o menu fica sempre visível */
    max-height: none;
    overflow: visible;
  }

  /* Dropdown para "Legislação Estadual" no desktop */
  .links-navegacao .has-submenu {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  /* esconde o botão do menu no desktop */
  .menu-toggle { display: none; }

  .links-navegacao .has-submenu > a {
    white-space: nowrap;
  }

  .links-navegacao .has-submenu .coluna-links {
    /* Posição do submenu */
    position: absolute;
    background-color: #115810;
    left: 50%;
    bottom: 100%; /* aparece baixo do item principal */
    // background-color: #115810;
    // border: 1px solid #ffb24e;
    padding: 0.5rem 0;
    margin: 0;
    z-index: 1000;
    min-width: 260px;
    // box-shadow: 0 4px 10px rgba(0,0,0,0.25);

    /* Layout interno */
    display: flex;
    flex-direction: column;
    gap: 0;

    /* Estado inicial oculto com animação preparada */
    visibility: hidden;
    opacity: 0;
    transform: translate(-50%, 8px) scaleY(0.9);
    transform-origin: bottom center; /* anima de baixo para cima */
    transition: opacity 0.2s ease, transform 0.25s cubic-bezier(.2,.6,.2,1);
    pointer-events: none;
  }

  .links-navegacao .has-submenu:hover .coluna-links {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, 0) scaleY(1);
    pointer-events: auto;
  }

  .links-navegacao .has-submenu .coluna-links a {
    display: block;
    /* animação item-a-item (inicialmente ocultos e deslocados para baixo) */
    opacity: 0;
    transform: translateY(8px);
    transition: opacity 0.18s ease, transform 0.22s cubic-bezier(.2,.6,.2,1);
  }

  /* torna os itens visíveis e alinhados quando hover abre o submenu */
  .links-navegacao .has-submenu:hover .coluna-links a {
    opacity: 1;
    transform: translateY(0);
  }

  /* escalonamento (3 itens): último aparece primeiro */
  .links-navegacao .has-submenu:hover .coluna-links a:nth-child(3) { transition-delay: 0s; }
  .links-navegacao .has-submenu:hover .coluna-links a:nth-child(2) { transition-delay: 0.08s; }
  .links-navegacao .has-submenu:hover .coluna-links a:nth-child(1) { transition-delay: 0.16s; }
}
.btn-municipal.active-municipal {
  background-color: #0e489f;
  color: #ffb24e;
  font-weight: 900;
  text-shadow: 0 1px 1px rgba(0,0,0,0.35);
}

</style>
<style scoped>
/* Tamanho do ícone do link "Legislação Municipal" */
.icon-municipal {
  width: 100%;
  max-width: 150px;
  /* height: 30px; */
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
}

/* Opcional: no hover, mantém consistência do botão atual */
.btn-municipal:hover .icon-municipal {
  /* filter: none; */
  background-color: #d3d4d3;
  width: fit-content;
}

.only-estadual-right {
  display: flex;
  justify-content: flex-end;
}

</style>
